import { PagedMessageResponse } from "app/api/types/PagedMessageResponse"
import { Paginacao } from "app/components/itens-orcamento/paginacao/Paginacao"
import { IItemOrcamento } from "app/types/IItemOrcamento"
import globalMU from "globalMU"
import React from "react"

const estiloTabela = require('../../../estilos/tabelas.module.scss').default

export type DadosOrdemProducaoEmAberto = {
    Filial: string
    OrdemProducao: number
    Quantidade: number
    DataInclusao: string
    DataPrevistaProducao: string
    DataPrevistaEntrega: string
    Situacao: string
    EtapaProducao: number
    PedidoVenda: number
    Cliente: string
    Vendedor: string
    UserMessage: string,
    Transforming: boolean
}

export type ConsultaOrdemDeProducaoAbertoProps = {
    item: IItemOrcamento
    dadosOrdemProducao: Partial<PagedMessageResponse<DadosOrdemProducaoEmAberto>>
    onAlterarListaSelecionada: (numeroPagina: number) => void
}

export const ConsultaOrdemDeProducaoAberto = (props: ConsultaOrdemDeProducaoAbertoProps) => {

    const headerTabela = () => {
        const mapHeader = ["Filial", "Ordem Produção", "Quantidade", "Data Inclusão", "Data Prevista Produção",
            "Data Prevista Entrega", "Situação", "Fase Produção", "Pedido Venda", "Cliente", "Vendedor"]

        return mapHeader.map((nome) => <th key={nome} className="_table-cell">{nome}</th>)
    }

    const bodyTabela = (dado: DadosOrdemProducaoEmAberto) => {
        const mapHeader = [dado.Filial, dado.OrdemProducao, globalMU.formatarValorNumerico(dado.Quantidade, 3, false),
        globalMU.formatDate(dado.DataInclusao), globalMU.formatDate(dado.DataPrevistaProducao),
        globalMU.formatDate(dado.DataPrevistaEntrega), dado.Situacao, dado.EtapaProducao, dado.PedidoVenda, dado.Cliente, dado.Vendedor]

        return mapHeader.map((nome, indice) => <td key={indice} className="_table-cell">{nome}</td>)
    }

    return (
        <>

            <div className="_flex _items-center _my-2">
                <label className="_text-right _bg-[#e4e6e8] _w-[160px] _font-normal _mb-0 _p-2">Produto</label>
                <div className="_pl-[10px] _pb-[5px]">{props.item?.Codigo} - {props.item?.Descricao}</div>
            </div>

            <table className={`_table _w-full _border-collapse _mt-2 ${estiloTabela.tabela}`}>
                <thead className="_table-header-group">
                    <tr className="_table-row">
                        {headerTabela()}
                    </tr>
                </thead>

                <tbody className="_table-row-group">
                    {props.dadosOrdemProducao?.Entities?.map((dado) => (
                        <tr key={`${dado.Filial}-${dado.OrdemProducao}`} className="_table-row">
                            {bodyTabela(dado)}
                        </tr>
                    ))}
                </tbody>
            </table>

            {props.dadosOrdemProducao?.PageCount > 1 && (
                <div className="_my-2">
                    <Paginacao
                        paginaAtual={props.dadosOrdemProducao?.ActualPage}
                        totalPaginas={props.dadosOrdemProducao?.PageCount}
                        id="ConsultaOrdemDeProducaoAberto_Paginacao"
                        onAlterarListaSelecionada={props.onAlterarListaSelecionada}
                    />
                </div>
            )}
        </>
    )
}
